<template>
  <div id="user-edit-account-details">
    <div class="vx-row">
      <div class="vx-col w-full">
        <h3>URLs</h3>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-input class="w-full mt-4"
                  label="Allowed Callback URLs"
                  v-model="callbacks"
                  name="callbacks" />
        <span class="text-danger text-sm"  v-show="vErrors.has('callbacks')">{{
            vErrors.first('callbacks')
          }}</span>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-input class="w-full mt-4"
                  label="Allowed Logout URLs"
                  v-model="allowed_logout_urls"
                  name="allowed_logout_urls" />
        <span class="text-danger text-sm"  v-show="vErrors.has('allowed_logout_urls')">{{
            vErrors.first('allowed_logout_urls')
          }}</span>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-input class="w-full mt-4"
                  label="Allowed Web Origins"
                  v-model="web_origins"
                  name="web_origins" />
        <span class="text-danger text-sm"  v-show="vErrors.has('web_origins')">{{
            vErrors.first('web_origins')
          }}</span>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-input class="w-full mt-4"
                  label="Allowed Web Origins (CORS)"
                  v-model="allowed_origins"
                  name="allowed_origins" />
        <span class="text-danger text-sm"  v-show="vErrors.has('allowed_origins')">
          {{
            vErrors.first('allowed_origins')
          }}
        </span>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.value)),
      allowed_origins_local: [],
    }
  },
  computed: {
    callbacks: {
      get () {
        return this.data_local.ExternalIdentity.callbacks.join(',');
      },
      set (value) {
        this.data_local.ExternalIdentity.callbacks = this.resolveStringToArray(value);
      }
    },
    allowed_logout_urls: {
      get () {

        return this.data_local.ExternalIdentity.allowed_logout_urls.join(',');
      },
      set (value) {
        this.data_local.ExternalIdentity.allowed_logout_urls = this.resolveStringToArray(value);
      }
    },
    web_origins: {
      get () {
        return this.data_local.ExternalIdentity.web_origins.join(',');
      },
      set (value) {
        this.data_local.ExternalIdentity.web_origins = this.resolveStringToArray(value);
      }
    },
    allowed_origins: {
      get () {
        return this.data_local.ExternalIdentity.allowed_origins.join(',');
      },
      set (value) {
        this.data_local.ExternalIdentity.allowed_origins = this.resolveStringToArray(value);
      }
    }
  },
  watch: {
    data_local: {
      handler(newData) {
        this.$emit('input', newData);
      },
      deep: true,
    },
  },
  methods: {
    resolveStringToArray(value) {
      return value.length === 0 ? [] : value.split(',');
    }
  },
}
</script>
